( function( window, document, $ ) {
    'use strict';

    /* -------------------------------------------------- */
    /* EVENTS */
    /* -------------------------------------------------- */
    $( document ).ready( function() {
        // Add DOM-related logic here.

        //
        // PJAX
        //
        var smoothstate_options = {
                blacklist: '.no-smoothstate, .Galleryrow a', // `.Galleryrow a`  - thumbnail links to individual FooGallery galleries (eg, ones found on https://torontofashionweek.to/press-gallery-february-2018/)
                prefetch: true,
                cacheLength: 2,
                scroll: false,
                onStart: {
                    duration: 250,
                    render: function( $container ) {
                        $container.addClass( 'is-exiting' );
                        smoothState.restartCSSAnimations();
                    },
                },
                onReady: {
                    duration: 0,
                    render: function( $container, $newContent ) {
                        // Remove your CSS animation reversing class
                        $container.removeClass( 'is-exiting' );

                        // Inject the new content
                        $container.html( $newContent );
                    },
                },
                onAfter: function() {
                    $( window ).scrollTop( 0 );

                    // Re-run all JS functions whenever new page loads:
                    initCountdownClock();
                    initDrawerNav();
                    initGallerySwipe();
                    initGoogleMap();
                    initHeroVideo();
                    pjaxUpdateGoogleAnalytics();
                    $( '.foogallery' ).foogallery();
                },
            },

            smoothState = $( '#content' ).smoothState( smoothstate_options ).data( 'smoothState' );

        //
        // UPDATE GOOGLE ANALYTICS ON PJAX PAGE CHANGE
        //
        function pjaxUpdateGoogleAnalytics() {

            if ( typeof ga === 'function' ) {
                ga( 'set', 'location', smoothState.href );
                ga( 'send', 'pageview' );
            } else {
                console.log( 'Google Analytics Tracking ID not detected.' );
            }
        }

        //
        // MAIN PAGE HERO VIDEO
        //
        var sjmHeroVideo;

        function initHeroVideo() {

            sjmHeroVideo = document.getElementById( 'js--hero-video' );

            // NOTE: If a URL for a mobile-sized video is provided, that file is set as the video src (to prevent mobile devices from starting to load desktop-sized video before being switched). If the screen width is above 768, switch video source to the desktop sized file.
            if ( sjmHeroVideo && $( window ).width() > 768 && sjmHeroVideo.dataset.desktopVideoSrc ) {
                var sjmDesktopVideoSrc = $( '#js--hero-video' ).data( 'desktop-video-src' );
                $( '#js--hero-video source' ).attr( 'src', sjmDesktopVideoSrc );
                $( sjmHeroVideo )[ 0 ].load();
            }

            // Initialize plyr.js
            var sjmPlyr = plyr.setup( '#js--hero-video', {
                controls: [ 'play', 'mute' ],
                autoplay: true,
            } );

            if ( typeof sjmPlyr === 'object' && sjmPlyr[ 0 ] && sjmPlyr[ 0 ].length ) {

                if ( !sjmPlyr[ 0 ].isMuted() ) {
                    sjmPlyr[ 0 ].toggleMute();
                }

            }

        }

        initHeroVideo();


        //
        // DRAWER NAV
        //

        var sjmDrawerNavToggle;
        var sjmDrawerNavOverlay;
        var sjmDrawerNav;
        var sjmDrawerNavLinks;
        var sjmDrawerNavTiming;
        var sjmDrawerNavIsOpen;

        var sjmFocusedElement;
        var sjmPxFromTop;

        function initDrawerNav() {

            sjmDrawerNavToggle = $( '.js--toggle-menu' );
            sjmDrawerNavOverlay = $( '.js--drawer-nav-overlay' );
            sjmDrawerNav = $( '.js--drawer-nav' );
            sjmDrawerNavLinks = $( '.js--drawer-nav a' );
            sjmDrawerNavTiming = 50;
            sjmDrawerNavIsOpen = false;

            // var sjmFocusedElement;
            // var sjmPxFromTop;

            // Event listeners
            sjmDrawerNavToggle.on( 'click', function( e ) {
                e.preventDefault();
                sjmToggleDrawerNav();
            } );

            // Close drawer nav when menu link is clicked (so menu doesn't stay open when using PJAX):
            sjmDrawerNavLinks.on( 'click', function() {
                sjmToggleDrawerNav();
            } );

            // Close drawer nav when overlay is clicked:
            sjmDrawerNavOverlay.on( 'click', function( e ) {
                // Ignore clicks on descendent elements:
                if ( e.target !== this )
                    return;

                // Toggler drawer nav:
                sjmToggleDrawerNav();
            } );
        }

        initDrawerNav();

        function sjmFadeInDrawerNavItems() {
            $( '.js--drawer-nav ul li' ).each( function( index ) {
                $( this ).delay( 50 * index ).fadeIn( 200, 'linear' );
            } );
        }

        // Actions
        function sjmToggleDrawerNav() {
            if ( sjmDrawerNavIsOpen ) {
                sjmDrawerNav.removeClass( 'is-open' );
                sjmDrawerNavOverlay.removeClass( 'is-visible' );

                $( '.js--drawer-nav ul li' ).hide();

                sjmDrawerNavIsOpen = false;
            } else {
                sjmDrawerNavOverlay.addClass( 'is-visible' );
                sjmDrawerNav.addClass( 'is-open' );

                setTimeout( sjmFadeInDrawerNavItems, 50 );

                sjmDrawerNavIsOpen = true;
            }

            // Wait until fade animation is done, then unfreeze body
            setTimeout( sjmFreezePageBody, sjmDrawerNavTiming + 50 );
        }

        function sjmFreezePageBody() {

            if ( sjmDrawerNavIsOpen ) {

                // "Freeze" the page body to prevent it from scrolling
                sjmPxFromTop = $( 'body' ).scrollTop();
                $( 'body' ).addClass( 'freeze' ).css( 'top', sjmPxFromTop * -1 );

                // For accessibility, save focused element when menu opens and return to focus there when menu closes
                sjmFocusedElement = document.activeElement;

            } else {

                // Un-freeze the page body
                $( 'body' ).removeClass( 'freeze' ).css( 'top', 0 ).scrollTop( sjmPxFromTop );

                // Accessibility:
                sjmFocusedElement.focus();

            }

        }


        //
        // COUNTDOWN CLOCK
        // Countdown timer from https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
        //

        function initCountdownClock() {
            if ( document.getElementById( 'js--countdown' ) ) {

                $( '.js--countdown-wrapper' ).show();

                var dateString = document.getElementById( 'js--countdown' ).dataset.date;

                var eventTime = new Date( Date.parse( dateString ) );
                // Format for `dateString` looks something like "April 27 2017 19:00:00"

                initializeClock( 'js--countdown', eventTime );

            }
        }

        initCountdownClock();

        function getTimeRemaining( endtime ) {
            var t = Date.parse( endtime ) - Date.parse( new Date() );
            var seconds = Math.floor( ( t / 1000 ) % 60 );
            var minutes = Math.floor( ( t / 1000 / 60 ) % 60 );
            var hours = Math.floor( ( t / ( 1000 * 60 * 60 ) ) % 24 );
            var days = Math.floor( t / ( 1000 * 60 * 60 * 24 ) );
            return {
                'total': t,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds,
            };
        }

        function initializeClock( id, endtime ) {
            var clock = document.getElementById( id );
            var daysDiv = clock.querySelector( '.js--days' );
            var hoursDiv = clock.querySelector( '.js--hours' );
            var minutesDiv = clock.querySelector( '.js--mins' );
            var secondsDiv = clock.querySelector( '.js--secs' );


            // Wrap each number in a <span> and output it
            function outputClockNumbers( timeArray ) {

                var stringReturn = '';
                timeArray.forEach( function( item, index ) {
                    stringReturn += '<span>' + timeArray[ index ] + '</span>';
                } );
                return stringReturn;

            }


            function updateClock() {

                var t = getTimeRemaining( endtime );

                // If num of days in single digit, add 0 before
                if ( t.days.toString().length === 1 ) {
                    t.days = '0' + t.days.toString();
                }

                var clockDays = ( t.days === 0 ? '00' : t.days ).toString().split( '' ) ;
                var clockHours = ( '0' + t.hours ).slice( -2 ).toString().split( '' );
                var clockMinutes = ( '0' + t.minutes ).slice( -2 ).toString().split( '' );
                var clockSeconds = ( '0' + t.seconds ).slice( -2 ).toString().split( '' );

                daysDiv.innerHTML = outputClockNumbers( clockDays );
                hoursDiv.innerHTML = outputClockNumbers( clockHours );
                minutesDiv.innerHTML = outputClockNumbers( clockMinutes );
                secondsDiv.innerHTML = outputClockNumbers( clockSeconds );

                if ( t.total <= 0 ) {
                    clearInterval( timeinterval );
                }
            }

            updateClock();
            var timeinterval = setInterval( updateClock, 1000 );
        }

        //
        // GOOGLE MAP
        //

        function initGoogleMap() {

            var map_container = $( '#map' );

            if ( map_container.length ) {
                initMap( map_container );
            }
        }

        initGoogleMap();

        function initMap( map_container ) {

            // Get map coordinates from data tags on container div
            var gmap_lat = parseFloat( map_container.data( 'lat' ) );
            var gmap_lng = parseFloat( map_container.data( 'lng' ) );

            var mapCenter = {
                lat: gmap_lat,
                lng: gmap_lng,
            };

            var map = new google.maps.Map( document.getElementById( 'map' ), {
                zoom: 17,
                scrollwheel: false,
                center: mapCenter,
                mapTypeControl: false,
                streetViewControl: false,
                fullScreenControl: false,
                styles: [
                    {
                        featureType: 'poi.business',
                        stylers: [ { visibility: 'off' } ],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [ { visibility: 'off' } ],
                    },
                ],
            } );

            var marker = new google.maps.Marker( {
                position: mapCenter,
                map: map,
                // icon: {
                //     url: wp_vars.theme_url + '/images/icon-map-marker.png',
                //     scaledSize: new google.maps.Size( 145, 60 ),
                // },
            } );

            google.maps.event.addDomListener( window, 'resize', function() {
                map.setCenter( mapCenter );
            } );

        }


        //
        // INITIALIZE OBJECTFITIMAGES.JS
        // Fallback for object-fit images in IE
        //
        objectFitImages();


        //
        // PHOTOSWIPE LIGHTBOX GALLERY
        //
        function openPhotoSwipe( clickedIndex ) {
            var pswpElement = document.querySelectorAll( '.pswp' )[ 0 ];

            // NOTE - If there are multiple galleries on the page, `tfwGallery` will be an array of arrays containing image data; otherwise, if there is only one gallery on the page, `tfwGallery` will simply be an array containing image data
            // NOTE - `clickedIndex` is only relevant if there are multiple galleries; on a single designer page—where there is only one gallery—the value is not passed to this function
            var items = ( typeof clickedIndex === 'undefined' ) ? tfwGallery : tfwGallery[ clickedIndex ];

            var options = {
                barsSize: {
                    top: 100,
                    bottom: 145,
                },

                showAnimationDuration: 0,
                hideAnimationDuration: 0,
                closeEl: true,
                captionEl: true,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                closeOnScroll: false,
                clickToCloseNonZoomable: false,

                // Disable zooming in on images https://github.com/dimsemenov/PhotoSwipe/issues/846#issuecomment-121599761
                maxSpreadZoom: 1,
                getDoubleTapZoom: function( isMouseClick, item ) {
                    return item.initialZoomLevel;
                },
                pinchToClose: false,

            };

            var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );

            // Make use of responsive imgs (http://photoswipe.com/documentation/responsive-images.html)
            // create variable that will store real size of viewport
            var realViewportWidth,
                imgSize = 320,
                firstResize = true,
                imageSrcWillChange;

            // beforeResize event fires each time size of gallery viewport updates
            gallery.listen( 'beforeResize', function() {
                // gallery.viewportSize.x - width of PhotoSwipe viewport
                // gallery.viewportSize.y - height of PhotoSwipe viewport
                // window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
                //                          1 (regular display), 2 (@2x, retina) ...


                // calculate real pixels when size changes
                realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

                // Code below is needed if you want image to switch dynamically on window.resize

                // Find out if current images need to be changed
                if ( realViewportWidth >= 1600 ) {
                    imgSize = 1600;
                    imageSrcWillChange = true;

                } else if ( realViewportWidth >= 1280 ) {
                    imgSize = 1280;
                    imageSrcWillChange = true;

                } else if ( realViewportWidth >= 960 ) {
                    imgSize = 960;
                    imageSrcWillChange = true;

                } else if ( realViewportWidth >= 640 ) {
                    imgSize = 640;
                    imageSrcWillChange = true;

                } else if ( realViewportWidth >= 320 ) {
                    imgSize = 320;
                    imageSrcWillChange = true;
                }

                // Invalidate items only when source is changed and when it's not the first update
                if ( imageSrcWillChange && !firstResize ) {
                    // invalidateCurrItems sets a flag on slides that are in DOM,
                    // which will force update of content (image) on window.resize.
                    gallery.invalidateCurrItems();
                }

                if ( firstResize ) {
                    firstResize = false;
                }

                imageSrcWillChange = false;

            } );


            // gettingData event fires each time PhotoSwipe retrieves image source & size
            gallery.listen( 'gettingData', function( index, item ) {

                // Set image source & size based on real viewport width
                switch ( imgSize ) {
                case 1600:
                    item.src = item[ 'modal-gallery-1600' ][ 'src' ];
                    item.w = item[ 'modal-gallery-1600' ][ 'w' ];
                    item.h = item[ 'modal-gallery-1600' ][ 'h' ];
                    break;
                case 1280:
                    item.src = item[ 'modal-gallery-1280' ][ 'src' ];
                    item.w = item[ 'modal-gallery-1280' ][ 'w' ];
                    item.h = item[ 'modal-gallery-1280' ][ 'h' ];
                    break;
                case 960:
                    item.src = item[ 'modal-gallery-960' ][ 'src' ];
                    item.w = item[ 'modal-gallery-960' ][ 'w' ];
                    item.h = item[ 'modal-gallery-960' ][ 'h' ];
                    break;
                case 640:
                    item.src = item[ 'modal-gallery-640' ][ 'src' ];
                    item.w = item[ 'modal-gallery-640' ][ 'w' ];
                    item.h = item[ 'modal-gallery-640' ][ 'h' ];
                    break;
                case 320:
                    item.src = item[ 'modal-gallery-320' ][ 'src' ];
                    item.w = item[ 'modal-gallery-320' ][ 'w' ];
                    item.h = item[ 'modal-gallery-320' ][ 'h' ];
                    break;
                }


                // It doesn't really matter what will you do here,
                // as long as item.src, item.w and item.h have valid values.
                //
                // Just avoid http requests in this listener, as it fires quite often

            } );


            gallery.init();
        }

        function initGallerySwipe() {
            $( '.js--gallery-button' ).click( function() {
                // Get value of `data-gallery-index` attribute
                // NOTE - gallery buttons in single designer pages do not have a `data-gallery-index` attribute, since there is only one gallery; therefore `undefined` will be passed to the function (the function will handle this accordingly)
                var galleryIndex = this.dataset.galleryIndex;
                openPhotoSwipe( galleryIndex );
            } );
        }

        initGallerySwipe();

    } );

} )( window, document, jQuery );
